import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard.js';
import css from './ListingPage.module.css';

const EducationAndSpecializationsSection = ({
  certifications = [],
  workExperience = [],
  education = [],
  specializations = [],
  specializationDescriptions = {},
  specializationsList = [],
  language = 'en',
  showLessonPacks,
  LessonPackSection,
  currentListing,
  price,
  onManageDisableScrolling,
}) => {
  const [activeTab, setTab] = useState('certifications');

  const renderCerts = () => (
    (certifications || []).map(cert => {
      const { title, certificationsEndYear, certificationsStartYear, certificationsDescription } = cert;
      const key = cert.id || `${title}-${certificationsStartYear}-${certificationsEndYear}`;
      return (
        <div key={key} className={css.educationItem}>
          <div className={css.educationItemIcon}>
            <IconCard type="college" />
          </div>
          <div className={css.educationItemContent}>
            <div className={css.educationItemTitle}>{title}</div>
            <div className={css.educationItemDescription}>{certificationsDescription}</div>
            <div className={css.educationItemYear}>
              <span>{certificationsStartYear}</span>-<span>{certificationsEndYear}</span>
            </div>
          </div>
        </div>
      );
    })
  );

  const renderWork = () => (
    (workExperience || []).map(exp => {
      const { title, workExperienceEndYear, workExperienceStartYear, workExperienceDescription } = exp;
      const key = exp.id || `${title}-${workExperienceStartYear}-${workExperienceEndYear}`;
      return (
        <div key={key} className={css.educationItem}>
          <div className={css.educationItemIcon}>
            <IconCard type="college" />
          </div>
          <div className={css.educationItemContent}>
            <div className={css.educationItemTitle}>{title}</div>
            <div className={css.educationItemDescription}>{workExperienceDescription}</div>
            <div className={css.educationItemYear}>
              <span>{workExperienceStartYear}</span>-<span>{workExperienceEndYear}</span>
            </div>
          </div>
        </div>
      );
    })
  );

  const renderEdu = () => (
    (education || []).map(ed => {
      const { title, description, startYear, endYear } = ed;
      const key = ed.id || `${title}-${startYear}-${endYear}`;
      return (
        <div key={key} className={css.educationItem}>
          <div className={css.educationItemIcon}>
            <IconCard type="college" />
          </div>
          <div className={css.educationItemContent}>
            <div className={css.educationItemTitle}>{title}</div>
            <div className={css.educationItemDescription}>{description}</div>
            <div className={css.educationItemYear}>
              <span>{startYear}</span>-<span>{endYear}</span>
            </div>
          </div>
        </div>
      );
    })
  );

  const renderSpecializations = () => (
    (specializations || []).map(sp => {
      const key = typeof sp === 'string' ? sp : sp?.value;
      if (!key) return null;
      const item = (specializationsList || []).find(s => s.value === key || s.key === key);
      if (!item) return null;
      const label = language === 'ar' ? item.label_ar : (item.label_en || item.label);
      const description = specializationDescriptions[key];
      return (
        <div key={key} className={css.specializationItem}>
          <div className={css.specializationItemContent}>
            <div className={css.specializationItemTitle}>{label}</div>
            <div className={css.specializationItemDescription}>{description}</div>
          </div>
        </div>
      );
    })
  );

  return (
    <div className={css.educationSection}>
      <div className={css.educationContainer}>
        <div className={css.educationHeader}>
          <div className={css.educationHeading}>
            <IconCard type="education" />
            <FormattedMessage id="ListingPage.educationHeading" />
          </div>
          <div className={css.educationTabs}>
            <div
              className={`${css.tab} ${activeTab === 'certifications' ? css.active : ''}`}
              onClick={() => setTab('certifications')}
            >
              <FormattedMessage id="ListingPage.tabs.certifications" />
            </div>
            <div
              className={`${css.tab} ${activeTab === 'education' ? css.active : ''}`}
              onClick={() => setTab('education')}
            >
              <FormattedMessage id="ListingPage.tabs.education" />
            </div>
            <div
              className={`${css.tab} ${activeTab === 'workExperience' ? css.active : ''}`}
              onClick={() => setTab('workExperience')}
            >
              <FormattedMessage id="ListingPage.tabs.workExperience" />
            </div>
          </div>
        </div>
        <div className={css.educationContent}>
          {activeTab === 'certifications' && renderCerts()}
          {activeTab === 'education' && renderEdu()}
          {activeTab === 'workExperience' && renderWork()}
        </div>
      </div>
      
      {showLessonPacks && LessonPackSection && (
        <div style={{ marginTop: '30px', marginBottom: '30px' }}>
          <LessonPackSection
            listing={currentListing}
            price={price}
            onManageDisableScrolling={onManageDisableScrolling}
          />
        </div>
      )}

      {/* Specializations below education */}
      {Array.isArray(specializations) && specializations.length > 0 ? (
        <div className={css.specializationsContainer}>
          <div className={css.specializationsHeading}>
            <FormattedMessage id="ListingPage.specializationsHeading" />
          </div>
          {renderSpecializations()}
        </div>
      ) : null}
    </div>
  );
};

export default EducationAndSpecializationsSection;
